export const abacusConfig = {
  adminRoleName: 'admin',
  enablePersistentFilters: false,
  flashMessageTimeout: 5000
}
